module.exports = __webpack_public_path__ + "static/media/rewards.f6e7acd0.svg";